/**
 * Base placement options for popper overlays
 * @public
 */
export const basePlacements = ['top', 'right', 'bottom', 'left'] as const;

/**
 * @public
 */
export type basePlacementsType = (typeof basePlacements)[number];
